import * as React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export function StatCardSkeleton() {
  return (
    <div className="flex flex-col items-center p-6 sm:p-8 bg-gray-800 rounded-xl border border-gray-700">
      {/* Label */}
      <Skeleton className="h-3 w-32 mb-2" />

      {/* Main number */}
      <Skeleton className="h-12 w-40 mb-2" />

      {/* Subtitle */}
      <Skeleton className="h-4 w-24 mt-2" />
    </div>
  );
}

export function LeaderBoardRowSkeleton() {
  return (
    <div className="flex items-center gap-4 p-3 bg-gray-800 rounded-lg">
      {/* Rank */}
      <Skeleton variant="circular" className="w-8 h-8" />

      {/* Avatar */}
      <Skeleton variant="circular" className="w-10 h-10" />

      {/* User info */}
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-3 w-32" />
      </div>
    </div>
  );
}

export function TopPatternRowSkeleton() {
  return (
    <div className="flex items-center gap-4 p-3 bg-gray-800 rounded-lg">
      {/* Rank badge */}
      <Skeleton className="w-8 h-8 rounded-lg" />

      {/* Pattern info */}
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}
